import React from "react";

const MyProfile = () => {
	return <h4 class="fw-bold py-3 mb-4">My Profile</h4>;
};

export default MyProfile;
